/**
 * Update slide indicator for hover-images on desktop
 * Listens to Flickity events and updates CSS variables
 */

(function() {
  'use strict';

  // Only run on desktop (no touch support)
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    return;
  }

  // Listen for Flickity select events on hover-images
  document.addEventListener('DOMContentLoaded', function() {
    initHoverImagesIndicators();
  });

  // Also initialize on dynamic content load
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          initHoverImagesIndicators();
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function initHoverImagesIndicators() {
    const hoverImagesElements = document.querySelectorAll('hover-images:not([data-hover-indicator-init])');

    hoverImagesElements.forEach(function(hoverImages) {
      // Mark as initialized immediately
      hoverImages.setAttribute('data-hover-indicator-init', 'true');

      const slider = hoverImages.querySelector('.product-item__bg__slider');
      if (!slider) {
        return;
      }

      if (!slider.classList.contains('flickity-enabled')) {
        return;
      }

      // Flickity instance is stored on the hover-images element, not the slider
      const flickityInstance = hoverImages.flkty;

      if (!flickityInstance) {
        return;
      }

      const slideCount = flickityInstance.slides.length;

      // Set initial CSS variables
      hoverImages.style.setProperty('--slides-count', slideCount);
      hoverImages.style.setProperty('--slider-index', flickityInstance.selectedIndex);

      // Listen to Flickity change event
      flickityInstance.on('change', function(index) {
        hoverImages.style.setProperty('--slider-index', index);
      });
    });
  }
})();
